import { useRef, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const UploadField = ({ refreshData, setShowToast, postDocumentFunction }) => {
  const [file, setFile] = useState(null);
  const [disableButtons, setDisableButtons] = useState(false);
  const fileInputRef = useRef(null);

  const handleSetFile = (e) => {
    const file = e?.target?.files?.[0];
    if (file?.name?.slice(-4).toLowerCase() === 'xlsx' || file?.name?.slice(-3).toLowerCase() === 'xls') {
      setFile(file);
    }
  };

  const handleBrowseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleUploadClick = async (e) => {
    setDisableButtons(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', file.name);

    try {
      const response = await postDocumentFunction(formData);
      if (response[0]?.response === 'Success') {
        refreshData(); // Trigger the refresh
      }
    } catch (error) {
      if (error?.message) {
        const errorMessage = JSON.parse(error.message).error;
        setShowToast({
          toastTitle: 'Error',
          toastBody: errorMessage,
        });
      }
    } finally {
      setFile(null);
      setDisableButtons(false);
    }
  };

  return (
    <Row md={12} className="d-flex gap-2 mt-2 ms-3">
      <Col md={4}>
        <Form.Control type="text" value={file?.name ? file.name : 'Select a file'} disabled />
      </Col>
      <Col md={6} className="d-flex gap-2">
        <Form.Control
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleSetFile}
          accept=".xlsx, .xls"
        />

        <button onClick={handleBrowseClick} disabled={disableButtons}>
          Browse
        </button>
        <button onClick={handleUploadClick} disabled={!file || disableButtons}>
          Upload
        </button>
      </Col>
    </Row>
  );
};

export default UploadField;
